module.exports = __webpack_public_path__ + "static/media/img-messaging-mobile.f7b21709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-messaging-mobile.png
// module id = 1066
// module chunks = 0